module.exports = __webpack_public_path__ + "img/curved-arrow-right.d385afc2.svg";